<template>
  <AccordionCard :title="$t('products.filters.price')">
    <div>
      <UiRangeSlider
        :has-inputs="true"
        :min-range="priceRange.minPrice"
        :max-range="priceRange.maxPrice"
        :to-reset-vals="isResetted"
        :locale="getLocaleCode()"
        :selected-value="selectedPrice"
        :debounce-ms="2000"
        @values-selected="updateSelectedPrice"
        @range-resetted="emit('resetted')"
      />
    </div>
  </AccordionCard>
</template>

<script lang="ts" setup>
import UiRangeSlider from '@sephora-asia/ui-range-slider/UiRangeSlider.vue'
import { type LocaleCodes } from '@sephora-asia/ui-range-slider/types'
import AccordionCard from './accordion-card.vue'
import type { PriceRangeFilter } from '~/types/api/data/product/filter/filter.types'

const props = defineProps<{
  priceRangeFilter: PriceRangeFilter
  isResetted: boolean
}>()
const emit = defineEmits<{
  (e: 'resetted'): void
}>()

const { trackEvent } = useGtmTrack()
const { getAcceptLanguage } = useI18nLocale()
const { selectedFilterParams, updateSelectedPriceRange, resolvePriceRange } =
  useProductListingFiltersStore()

const priceRange = computed(() => resolvePriceRange(props.priceRangeFilter))

const selectedPrice = computed(() => ({
  min: selectedFilterParams.priceRange['min-price'],
  max: selectedFilterParams.priceRange['max-price'],
}))

function getLocaleCode(): LocaleCodes {
  return getAcceptLanguage() as LocaleCodes
}

function onPriceRangeTracking(minMaxValues: number[]) {
  if (
    minMaxValues[0] === +selectedPrice.value.min &&
    minMaxValues[1] === +selectedPrice.value.max
  ) {
    return
  }

  const { minPrice: limitMin, maxPrice: limitMax } = priceRange.value
  const [minValue, maxValue] = minMaxValues

  const isInvalidMinValue = minValue < 0 || minValue <= limitMin
  const isInvalidMaxValue = maxValue < 0 || maxValue >= limitMax
  const cm8 = isInvalidMaxValue && isInvalidMinValue ? -1 : 1

  trackEvent({
    event: 'click',
    params: {
      event_category: 'Filters',
      event_action: 'Click price Filter',
      event_label: `from-${minValue}-to-${maxValue}`,
      cm8,
    },
  })
}

function updateSelectedPrice(values: number[]) {
  onPriceRangeTracking(values)
  updateSelectedPriceRange(values, priceRange.value)
}
</script>
